import { createClient } from '@supabase/supabase-js';
 
const SUPABASE_URL = 'https://azxkziljkqtkamcqvjsn.supabase.co';
const SUPABASE_KEY = 'sb_publishable_f9zjl1DdkWyPdN8GLgIlxw_NLhPeYaM';
 
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
 
